import type { IFieldOptions } from '@axo/form/feature/form-input/types';

export const netIncomeMonthlyFieldOption = {
  registerOptions: {
    deps: 'Frontend/GrossIncomeMonthly',
    required: 'error.required',
    min: {
      value: 1_000,
      message: 'NetIncomeMonthly.error.min',
    },
    max: {
      value: 100_000,
      message: 'NetIncomeMonthly.error.max',
    },
    validate: {
      isLowerThanGrossIncome: (value, form) => {
        const net = Number(value);
        const gross = Number(form['Frontend/GrossIncomeMonthly']);
        if (net >= gross) return 'NetIncomeMonthly.error.amount';
      },
    },
  },
  tooltipValidation: {
    message: 'NetIncomeMonthly.tooltip',
  },
} satisfies IFieldOptions;
